import { toast } from "react-toastify"
import React, { useEffect, useState } from "react"

import Config from "../../api/Config"
import { IDAM } from "../../api/Registry"
import { APPLICATION } from "../../utils/Constants"
import HttpServices from "../../services/HttpServices"
import { TwoToneModal } from "../../lib/fragments/TwoToneModal"
import { RouteHydration, classNames } from "../../utils/Helpers"
import { FloatingInput } from "../../components/utils/FloatingInput"
import { G_onInputBlurHandler, G_onInputChangeHandler } from "../../components/utils/InputHandlers"

export const AuthProviderConfig = ({ show, showOrHide, slug, reload }) => {
    const [state, setstate] = useState({
        posting: false,
        httpStatus: 200,
        status: 'pending',
        data: {
            provider: null
        },
        input: {
        }, errors: {
        }
    })

    const [copied, setCopied] = useState(false);
    const redirectURL = `${Config.APP_CORE}/api/v1/identity/auth/google/callback`

    const keyMapping: Record<string, string> = {
        GOOGLE_CLIENT_ID: "Google Client ID",
        GOOGLE_CLIENT_SECRET: "Google Client Secret",
    };

    const onCloseModal = async () => {
        showOrHide()

        // Reset the state on close
        setTimeout(() => {
            setstate((prev: any) => {
                const inputObject: Record<string, string> = {};
                const errorsObject: Record<string, string> = {};
                const dataObject: Record<string, string> = {
                    provider: null
                };

                return {
                    ...prev,
                    posting: false,
                    httpStatus: 200,
                    data: dataObject,
                    status: 'pending',
                    input: inputObject,
                    errors: errorsObject
                };
            });
        }, 300); // Adjust to match your modal closing animation duration
    }

    useEffect(() => {
        if (show) {
            const fetchAuthProviderDetails = async () => {
                let { status, httpStatus, data, input, errors } = state

                try {
                    const route = [":slug"].reduce(
                        (route, param, index) => RouteHydration(route, param, [slug][index]),
                        IDAM.PROVIDER_CONFIG
                    );

                    const response: any = await HttpServices.httpGet(route)
                    httpStatus = response.status

                    if (httpStatus === 200) {
                        const payload: any = response.data.payload
                        data.provider = payload.provider

                        data.provider.c.map((object: any) => {
                            input[object.k] = object.y;
                            errors[object.k] = '';
                        })

                        status = 'fulfilled'
                    } else {
                        status = 'rejected'
                    }
                } catch (error) {
                    status = 'rejected'
                    httpStatus = 0
                }

                setstate((prevState: any) => ({
                    ...prevState,
                    input,
                    errors,
                    status,
                    httpStatus,
                    loading: false,
                    data: {
                        ...prevState.data,
                    },
                }))
            }

            fetchAuthProviderDetails()
        }
    }, [show])

    const copyRedirectURLHandler = async () => {
        try {
            await navigator.clipboard.writeText(redirectURL);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy!', err);
        }
    }

    const onChangeHandler = (e: any) => {
        let { posting } = state
        if (posting) return

        let { input } = state
        let { errors } = state
        let output: any = G_onInputChangeHandler(e)

        const updatedInput = {
            ...input,
            [e.target.name]: output.value
        };

        const updatedErrors = {
            ...errors,
            [e.target.name]: output.error
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));
    }

    const onInputBlur = (e: any) => {
        let { posting } = state
        if (posting) return

        let { input } = state
        let { errors } = state

        const errorMsgTitle = keyMapping[e.target.name] ?? ''
        let output: any = G_onInputBlurHandler(e, errorMsgTitle, 3, 400)

        const updatedInput = {
            ...input,
            [e.target.name]: output.value
        };

        const updatedErrors = {
            ...errors,
            [e.target.name]: output.error
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));
    }

    const onFormSubmitHandler = (e: any) => {
        e.preventDefault()

        let { posting, input } = state
        if (posting) return

        let validity = true
        const inputArray = Object.keys(input)

        inputArray.forEach((inputObject: any) => {
            let oTarget = e.target[inputObject]

            const event = {
                target: {
                    name: oTarget.name,
                    required: oTarget.required,
                    value: oTarget.value.trim(),
                }
            }

            onInputBlur(event)
        })

        let { errors } = state
        const errorArray = Object.keys(errors)

        errorArray.forEach((errorObject) => {
            console.log('errorObject', errorObject);

            if (errors[errorObject].length > 0) {
                validity = false
            }
        })

        if (validity) {
            setstate((prev) => ({
                ...prev,
                posting: !prev.posting
            }))

            updateAuthProviderConfigurations()
        }
    }

    const updateAuthProviderConfigurations = async () => {
        let { input, httpStatus, data } = state

        try {
            const authProviderActionRoute = [":slug"]
                .reduce((route, param, index) =>
                    RouteHydration(route, param, [data.provider.s][index]),
                    IDAM.PROVIDER_CONFIG
                );

            let formData = new FormData()

            Object.keys(input).forEach((key) => {
                // Loop through input
                formData.append(key, input[key])
            });

            const response: any = await HttpServices.httpPut(authProviderActionRoute, formData)
            httpStatus = response.status

            console.log('response', response);

            if (httpStatus === 200) {
                showOrHide()
                reload()
            } else {
                toast.error(APPLICATION.ERR_MSG)
            }
        } catch (error) {
            toast.error(APPLICATION.ERR_MSG)
        }

        setstate((prev) => ({
            ...prev,
            posting: false,
        }));
    }

    return (
        <React.Fragment>
            <TwoToneModal
                show={show}
                status={state.status}
                showOrHide={onCloseModal}
                posting={state.posting}
                formAction={"Update"}
                onSubmit={onFormSubmitHandler}
                size={
                    state.status === 'fulfilled' ? "3xl"
                        : state.status === 'rejected' ? "md"
                            : "sm"
                }
                header={
                    <>
                        <div className="w-full flex flex-col h-full gap-y-2.5 px-2">
                            <div className="sm:col-span-8 flex-grow lg:col-span-7 text-primary mb-3 flex flex-col md:gap-y-3 gap-y-1">
                                <h2 className="text-2xl text-primary">
                                    Auth Provider Configuration
                                </h2>

                                <span className="block py-2 text-sm">
                                    Make changes to your authentication provider's configuration.
                                </span>
                            </div>
                        </div>
                    </>
                }
                contents={
                    <>
                        {
                            state.status === 'fulfilled' && (
                                <div className="w-full md:px-4 px-5">
                                    <h2 className="text-xl text-slate-700 dark:text-slate-200">
                                        {state.data.provider.e}
                                    </h2>

                                    <div className="w-full pt-3 pb-2 flex gap-x-2">
                                        {
                                            state.data.provider.f === 'Y' && (
                                                <span className="bg-slate-50 dark:bg-slate-800/10 text-slate-500 dark:text-slate-400 ring-slate-400 rounded-md px-2 py-1 text-xs ring-1 ring-inset capitalize text-center">
                                                    Default
                                                </span>
                                            )
                                        }

                                        <span className={classNames(
                                            state.data.provider.n ? 'bg-purple-50 dark:bg-purple-800/10 text-purple-500 dark:text-purple-400 ring-purple-400' : 'bg-red-50 dark:bg-red-800/10 text-red-600 dark:text-red-400 ring-red-400',
                                            "rounded-md px-2 py-1 text-xs ring-1 ring-inset capitalize text-center"
                                        )}>
                                            {state.data.provider.n ? 'Enabled' : 'Disabled'}
                                        </span>
                                    </div>

                                    <p className="text-sm pt-2 pb-2 text-slate-500 dark:text-slate-400">
                                        {state.data.provider.t}
                                    </p>

                                    <span className="text-red-500 dark:text-red-500 text-xs block py-1 mb-5">* Required</span>

                                    <div className="w-full">
                                        {
                                            state.data.provider.c.length > 0 && (
                                                state.data.provider.c.map((provider: any) => {

                                                    return (
                                                        <div key={`auth-prov-key-${provider.k}`} className="w-full mb-5">
                                                            <FloatingInput
                                                                name={provider.k}
                                                                label={`${keyMapping[provider.k]} *`}
                                                                required={true}
                                                                posting={state.posting}
                                                                value={state.input[provider.k]}
                                                                error={state.errors[provider.k]}
                                                                blurHandler={onInputBlur}
                                                                changeHandler={onChangeHandler}
                                                            />
                                                        </div>
                                                    )
                                                })
                                            )
                                        }
                                    </div>

                                    <div className="w-full my-6 rounded-md px-2 py-3 bg-slate-100 dark:bg-slate-800/70 text-slate-700 dark:text-slate-300">
                                        <h1 className="heading flex align-middle items-center pb-2">
                                            <div className="w-10 flex align-middle items-center">
                                                <span className="fa-duotone block mx-auto fa-circle-info fa-lg"></span>
                                            </div>

                                            <div className="flex-1 overflow-hidden">
                                                <span className="text-sm md:block flex gap-x-3">
                                                    Register the redirect URL below in your Google Cloud Console:
                                                </span>
                                            </div>
                                        </h1>

                                        <div className="relative w-full">
                                            <div className="flex items-center align-middle bg-slate-100 dark:bg-slate-900 my-2 border border-slate-300 dark:border-slate-600 text-slate-600 dark:text-white text-sm px-2 py-1 rounded-md gap-x-2">
                                                <pre className="overflow-hidden">
                                                    <code className="flex items-center align-middle">
                                                        {redirectURL}
                                                    </code>
                                                </pre>

                                                <div className="flex-none">
                                                    <span className="fa-duotone fa-copy fa-lg" onClick={copyRedirectURLHandler}></span>
                                                </div>
                                            </div>

                                            {
                                                copied && (
                                                    <div className="absolute top-0 right-0 -translate-y-full text-green-600 text-sm px-2 py-1 bg-white dark:bg-slate-800 rounded shadow animate-slide-up-fade">
                                                        ✅ Copied!
                                                    </div>
                                                )
                                            }
                                        </div>

                                    </div>
                                </div>
                            )
                        }
                    </>
                }
            />
        </React.Fragment>
    )
}